import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <p> All Right Reserved | Copyright &copy; 2024</p>
    </div>
  );
};

export default Footer;
